import api from '@/services/api'

export default {
    methods: {
        getFileNameFromURL(url) {
            return url && url.split('/').pop()
        },
        forceFileDownload(response, filename) {
            if (!filename) {
                return
            }
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
        },
        download(id, filename, actionPlan = false, pdaCheckin = false, status = false) {
            try {
                let url = ''
                if (actionPlan) {
                    url = `/evidence/${id}/downloads/${status}`
                } else if (pdaCheckin) {
                    url = `/pda-checkin/${id}/downloads/`
                } else {
                    url = `/goals/checkins/download/${id}`
                }

                api.get(url, {
                    responseType: 'arraybuffer',
                }).then((response) => {
                    this.forceFileDownload(response, filename)
                })
            } catch (e) {
                console.log(e)
            }
        },
    },
    computed: {
        evidenceFileName() {
            return this.post.kpi_checkin != null ? this.getFileNameFromURL(this.post.kpi_checkin.evidence) : ''
        },
    },
}
